import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    TextField,
    FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    InputAdornment,
    IconButton,
    Checkbox,
    ButtonGroup,
    Select,
    MenuItem,
    InputLabel,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, AddCircle, Backspace, CheckBox, CheckBoxOutlineBlank, Delete, RemoveCircle, Save, Search, Visibility, VisibilityOff } from '@mui/icons-material';

import { useSearchParams } from 'react-router-dom';
import { makeid  } from '../utils/ui_utils';
import { useAuth } from '../core/AuthProvider';
import { award_filter_subdict  } from '../definitions/match';
import { NumberInput } from '../components/NumberInput';
import { globalstyles } from '../lib/definitions';



const newaward = {
    award_name: '',
    award_description: '',
    point: 1,
    has_position: false,
    point_list: [],
    from_other_data: false,
    hide_from_screen: false,
    list_id: -1
}



const group_by_list = [
    { id: 'property', label: 'Proprietà (azienda)' },
    { id: 'cowman', label: 'Allevatore' },
    { id: 'cross_father', label: 'cross Padre' }
    //{id: 'region', label: 'Regione'}
]

const sum_param_list = [
    { id: 'point', source: 'match', label: 'punteggio', filter_list:['all', 'position'] },
    { id: 'pft', source: 'match', label: 'gpft' },
    { id: 'ies', label: 'Indice IES', import_id: 'ies' },
    { id: 'ics_pr', label: 'Indice ics-pr', import_id: 'ics_pr' },
    { id: 'iqj', label: 'Indice IQJ', import_id: 'iqj' },
    { id: 'health_index', label: 'Indice benessere', import_id: 'benessere' },
    { id: 'kg_protein_index', source: 'match', label: 'Indice Kg Proteina' },
    { id: 'protein_kg', source: 'match', label: 'proteina Kg soggetto' },
    { id: 'lf_kg_milk', label: 'latte Kg lifetime', import_id: 'lf_kg_latte' },
    { id: 'lf_kgpt', label: 'proteina Kg lifetime', import_id: 'lf_kgpt' },
]



export const AwardDialog = forwardRef(({ event_id, reloadFn, t, add_Award, edit_Award , custom_filter}, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newaward })
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [searchParams, setSearchParams] = useSearchParams()






    useImperativeHandle(ref, () => {
        return {
            onNew(list) {
                setCurElement({ ...newaward, id: makeid(6), order: list ? list.length + 1 : 1 })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newaward, ...el }
                setCurElement(_el)
                initData(is_c, el.id)
                setIndex(i)
                setIsEdited(false)
            }
        }
    })


    const handleClose = () => {
        setSearchParams({})
        setOpen(false);
    };


    const handleSave = () => {
        if (is_new) {
            add_Award(curElement)
        } else {
            edit_Award(curElement, index)
        }
        setOpen(false)
    }



    const onChangeHandler = (el) => {
        let { name, value, type } = el
        console.log(el)
        console.log("V", name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'list') {
            let _l = []
            if (curElement[name]) {
                _l = [...curElement[name]]
            }
            const k = _l.indexOf(value)
            if (k < 0) {
                _l.push(value)
            } else {
                _l.splice(k, 1)
            }
            value = _l
        } else if (type === 'checkbox') {
            value = el.checked
        } else if (type === 'number') {
            value = parseInt(value)
        }

        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }
    }








    const initData = async (is_current, s_id) => {

    }

    useEffect(() => {
        return () => {

        }

    }, [])


    const isInvalid = () => {
        if (!curElement.is_global && curElement.filter_data === undefined) {
            console.log("MISSING IFLTER DATA")
            return false
        }
        if (curElement.award_name.length === 0) {
            console.log("MISSING NAME")
            return false
        }
        return false
    }


    const incrementValue = (param, i) => {
        setCurElement(e => {
            let v = parseInt(e[param][i])
            let _l = [...e[param]]
            _l.splice(i, 1, v + 1)

            return { ...e, [param]: _l }
        })
        setIsEdited(true)

    }
    const decrementValue = (param, i) => {
        setCurElement(e => {
            let v = parseInt(e[param][i])
            let _l = [...e[param]]
            _l.splice(i, 1, v - 1)

            return { ...e, [param]: _l }
        })
        setIsEdited(true)

    }


    const addPoint = () => {
        let _p_list = []
        if (curElement.point_list) {
            _p_list = [...curElement.point_list]
        }
        _p_list.push(0)
        const name = 'point_list'
        setCurElement({ ...curElement, [name]: _p_list })
        setIsEdited(true)
    }

    const removePoint = (k) => {
        let _p_list = [...curElement.point_list]
        _p_list.splice(k, 1)
        const name = 'point_list'
        setCurElement({ ...curElement, [name]: _p_list })
        setIsEdited(true)
    }

    const onChangeHandlerPoints = (el, index) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        value = parseInt(value)


        if (value !== undefined) {
            let _p_list = [...curElement.point_list]
            _p_list.splice(index, 1, value)
            console.log(name, value, _p_list)
            setCurElement({ ...curElement, point_list: _p_list })
            setIsEdited(true)
        }
    }







    return (
        <div>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth={true}>
                <DialogTitle>
                    Dati Premio:  {curElement.award_name}
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <NumberInput
                            value={curElement.order}
                            label={'ordine di visualizzazione'}
                            name="order"
                            onChangeHandler={onChangeHandler}
                            setCurElement={setCurElement}
                            setIsEdited={setIsEdited}
                        />
                        <TextField
                            margin="dense"
                            id="award_name"
                            label={'Nome'}
                            fullWidth
                            name="award_name"

                            variant="standard"
                            value={curElement.award_name}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />

                        <TextField
                            margin="dense"
                            id="award_description"
                            label={'descrizione'}
                            fullWidth
                            name="award_description"
                            variant="standard"
                            value={curElement.award_description}
                            onChange={(ev) => onChangeHandler(ev.target)}
                        />
                        <Box sx={{ mb: 1 }}>
                            <ButtonGroup size="small">
                                <Button onClick={() => onChangeHandler({ name: 'from_other_data', value: false })} variant={!curElement.from_other_data ? 'contained' : 'outlined'}>Assegnazione manuale</Button>
                                <Button onClick={() => onChangeHandler({ name: 'from_other_data', value: true })} variant={curElement.from_other_data ? 'contained' : 'outlined'}>Da altri dati</Button>
                            </ButtonGroup>
                        </Box>
                        {curElement.from_other_data &&
                            <>
                                <FormControl sx={{ mt: 1, minWidth: 320 }} size="small">
                                    <InputLabel id="select_filter_label">Valori raggruppati per</InputLabel>
                                    <Select
                                        labelId="groupby-label"
                                        id="groupby"
                                        value={curElement.groupby}
                                        label="Valori raggruppati per"
                                        onChange={(ev) => onChangeHandler({ name: 'groupby', value: ev.target.value })}
                                    >
                                        <MenuItem value="">
                                            <em>seleziona valore</em>
                                        </MenuItem>
                                        {group_by_list.map((g, gk) => (
                                            <MenuItem key={gk} value={g.id}>
                                                {g.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormControl sx={{ mt: 1, minWidth: 320 }} size="small">
                                    <InputLabel id="select_filter_label">Valore ordinamento</InputLabel>
                                    <Select
                                        labelId="groupby-label"
                                        id="award_value"
                                        value={curElement.award_value}
                                        label="Valori ordinamento"
                                        onChange={(ev) => onChangeHandler({ name: 'award_value', value: ev.target.value })}
                                    >
                                        <MenuItem value="">
                                            <em>seleziona valore</em>
                                        </MenuItem>
                                        {sum_param_list.map((g, gk) => (
                                            <MenuItem key={gk} value={g.id}>
                                                {g.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Box sx={{ mb: 1 }}>
                                    <NumberInput

                                        value={curElement.limit_count || 0}
                                        label={'Numero massimo capi (0 = nessuno)'}
                                        name="limit_count"
                                        onChangeHandler={onChangeHandler}
                                        setCurElement={setCurElement}
                                        setIsEdited={setIsEdited}
                                    />
                                </Box>
                                {curElement.groupby !== undefined &&
                                <Box sx={{ mb: 1 }}>
                                    <ButtonGroup size="small">
                                        <Button onClick={() => onChangeHandler({ name: 'limit_in_single_match', value: false })} variant={!curElement.limit_in_single_match ? 'contained' : 'outlined'}>per gruppo</Button>
                                        <Button onClick={() => onChangeHandler({ name: 'limit_in_single_match', value: true })} variant={curElement.limit_in_single_match ? 'contained' : 'outlined'}>per gara</Button>
                                    </ButtonGroup>
                                </Box>
                                }
                            </>
                        }
                        <Box sx={{ mb: 1 }}>
                            <ButtonGroup size="small">
                                <Button onClick={() => onChangeHandler({ name: 'has_position', value: true })} variant={curElement.has_position ? 'contained' : 'outlined'}>Usa posizioni</Button>
                                <Button onClick={() => onChangeHandler({ name: 'has_position', value: false })} variant={!curElement.has_position ? 'contained' : 'outlined'}>premio assoluto</Button>
                            </ButtonGroup>
                        </Box>

                        {curElement.has_position &&
                            <>
                                <FormControl>
                                    <FormLabel id="demo-radio-buttons-group-label">Filtro lista per parziali</FormLabel>
                                    <ButtonGroup size="small" >
                                        {Object.values(award_filter_subdict).map((f, k) => (
                                            <Button
                                                sx={{ mr: 1 }}
                                                key={k}
                                                color={f.color}
                                                onClick={() => onChangeHandler({ name: 'filter_data_list', value: f.id, type: 'list' })}
                                                variant={curElement.filter_data_list?.includes(f.id) ? 'contained' : 'outlined'}
                                                startIcon={curElement.filter_data_list?.includes(f.id) ? <CheckBox /> : <CheckBoxOutlineBlank />}
                                            >
                                                {f.label}
                                            </Button>

                                        ))}
                                        {console.log("CUSTO FILTER", custom_filter)}
                                        {custom_filter?.map((f,k) => (
                                            <Button
                                                sx={{ mr: 1 }}
                                                key={k}
                                                color={'info'}
                                                onClick={() => onChangeHandler({ name: 'filter_data_list', value: f.param_name, type: 'list' })}
                                                variant={curElement.filter_data_list?.includes(f.param_name) ? 'contained' : 'outlined'}
                                                startIcon={curElement.filter_data_list?.includes(f.param_name) ? <CheckBox /> : <CheckBoxOutlineBlank />}
                                            >
                                                {f.param_name}
                                            </Button>
                                        ))}
                                        <Button
                                                onClick={() => onChangeHandler({ name: 'filter_data_list', value: [] })}
                                                startIcon={<Backspace />} 
                                                color="secondary"
                                                ></Button>
                                    </ButtonGroup>

                                </FormControl>


                            </>
                        }
                        <Box sx={globalstyles.list_container}>
                            <Grid container sx={{ alignItems: 'center', ...globalstyles.sectionHeader }}>
                                <Grid size={"grow"}>
                                    punti assegnati
                                </Grid>
                                <Grid sx={{ textAlign: 'right' }}>
                                    <Button disabled={!curElement.has_position && curElement.point_list?.length > 0} variant="contained" size="small" onClick={addPoint} startIcon={<AddBox />}>Aggiungi punteggio</Button>
                                </Grid>
                            </Grid>
                            {(!curElement.point_list || curElement.point_list.length === 0) ?
                                <Box sx={{ color: 'red' }}>nessun punteggio assegnato con questo premio</Box>
                                :
                                <Grid container sx={globalstyles.listHeader}>
                                    {curElement.has_position &&
                                        <Grid size={2}>
                                            posizione
                                        </Grid>
                                    }
                                    <Grid size={6}>
                                        punteggio
                                    </Grid>
                                    <Grid size={"grow"}>

                                    </Grid>
                                </Grid>
                            }
                            {console.log("POINT LIST", curElement.point_list)}
                            {curElement.point_list?.map((p, k) => (
                                <Grid container sx={{ alignItems: 'center', ...globalstyles.list_row }}>
                                    {curElement.has_position &&

                                        <Grid size={2}>
                                            {k + 1}
                                        </Grid>
                                    }
                                    <Grid size={6}>
                                        <TextField
                                            margin="dense"
                                            id="points"
                                            name="points"
                                            variant="standard"
                                            type="number"
                                            value={p}
                                            onChange={(ev) => onChangeHandlerPoints(ev.target, k)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment point="end">
                                                        <IconButton edge="end" color="primary" onClick={() => incrementValue('point_list', k)}>
                                                            <AddCircle />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                startAdornment: (
                                                    <InputAdornment point="start">
                                                        <IconButton disabled={parseInt(p) < 2} edge="start" color="primary" onClick={() => decrementValue('point_list', k)}>
                                                            <RemoveCircle />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid size="grow" sx={{ textAlign: 'right' }}>
                                        <Button size="small" variant="outlined" color="error" onClick={() => removePoint(k)} startIcon={<Delete />}></Button>
                                    </Grid>
                                </Grid>

                            ))}
                        </Box>
                        <Box sx={globalstyles.list_container}>
                            <Grid container sx={{ alignItems: 'center', ...globalstyles.sectionHeader }}>
                                <Grid size={"grow"}>
                                    su schermo esterno
                                </Grid>
                            </Grid>
                            <ButtonGroup size="small" style={{marginTop:2}}>
                                <Button onClick={() => onChangeHandler({ name: 'hide_from_screen', value: true })} variant={curElement.hide_from_screen ? 'contained' : 'outlined'} startIcon={<VisibilityOff />}>nascondi </Button>
                                <Button onClick={() => onChangeHandler({ name: 'hide_from_screen', value: false })} variant={!curElement.hide_from_screen ? 'contained' : 'outlined'} startIcon={<Visibility />}>visualizza</Button>
                            </ButtonGroup>
                        </Box>

                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {isEdited &&
                        <Button key={'bs'} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingpoint="start">Salva</Button>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})



